






































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { HomeworkSheetListCondition, RowSpanInfo } from "../../modules/teacher/HomeworkSheetList"


export interface Data {
  condition: HomeworkSheetListCondition
  sheets: any[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  school_id: number
  errors: string[]
  isShow: boolean
  ApiTypeEnum: Readonly<{None: number; Classroom: number; Teams: number}>
  selectedSheet: any
  users: any[]
  subjectNames: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const modalDigitalPaperPublishSetting = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.homeworkSheetListCondition,
      sheets: [],
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      school_id: context.root.$store.state.currentUser.school_id,
      errors: [],
      isShow: false,
      ApiTypeEnum: Common.ApiTypeEnum,
      selectedSheet: null,
      users: [],
      subjectNames: [],
    });

    const openDigitalPaperPublishSettingModal = (sheet: any) => {
      state.selectedSheet = sheet;
      modalDigitalPaperPublishSetting.value.show();
    }

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/homework_sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        const sheets = response.data.sheets;

        var sheetRowSpanInfos = [];
        for(var i = 0; i < sheets.length; i++){
          state.subjectNames = response.data.subject_names;
          var sheet = sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key){
            sheetRowSpanInfos.push({sheet_id: sheet.id, sheet_group_key: sheet.sheet_group_key, count: 1});
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        state.totalCount = sheets.length > 0 ? sheets[0].full_count : 0;
        state.sheets = sheets;
        state.sheets.forEach((x: any) => {
          x["digital_sheet_published_cache"] = x.digital_sheet_published;
        });

        state.users = response.data.users;

        context.root.$store.commit("setHomeworkSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 処理時間列用に時分秒表示にコンバート
     ******************************/

    const convertToHms = (time: number) => {
      var hms = "";
      var h = time / 3600 | 0;
      var m = time % 3600 / 60 | 0;
      var s = time % 60;

      if (h != 0) {
        hms = h + "時間" + padZero(m) + "分" + padZero(s) + "秒";
      } else if (m != 0) {
        hms = m + "分" + padZero(s) + "秒";
      } else {
        hms = s + "秒";
      }

      return hms;
    };

    /******************************
     * ゼロ埋め
     ******************************/

    const padZero = (v: number) => {
      if (v < 10) {
        return "0" + v;
      }
      else {
        return v;
      }
    };

    /******************************
     * rowspan設定
     ******************************/

    const rowSpan = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    }

    /******************************
     * セルのスタイル設定
     ******************************/

    const tdStyle = (sheet: any) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 行のCSSスタイル設定
     ******************************/

    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 締め切り日を画面表示文言にコンバート
     ******************************/

    const convertEndDate = (sheet: any) => {
      if(sheet.test_start_datetime_at && sheet.test_end_datetime_at){
        const format = 'Y年M月D日 HH:mm';
        return `${moment(sheet.test_start_datetime_at).format(format)}～<br>${moment(sheet.test_end_datetime_at).format(format)}&emsp;`;
      }else{
        return "-";        
      }
    };

    /******************************
     * 採点設定完了状態
     ******************************/

    const isSettingCompleted = (sheet: any) => {
      return sheet.field_positions_completed;
    }

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      const pageCache = state.condition.page;
      state.condition = new HomeworkSheetListCondition();
      state.condition.page = pageCache;
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験追加ボタン押下
     ******************************/

    const addSheetClick = () => {
      context.root.$router.push('/teacher_site/homework_sheet_edit/new').catch(err => {});
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/

    const saitenSettingClick = (sheet: any) => {
      context.root.$router.push(`/teacher_site/homework_sheet_edit/${sheet.sheet_group_key}`).catch(err => {});
    };

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * admin権限で表示される学校プルダウン変更
     ******************************/

    const schoolChanged = async () => {

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_admin_school/${state.school_id}`).then(response => {
        context.root.$store.commit("setCurrentUserSchoolId", state.school_id);
        context.root.$store.commit("setCurrentUserSchoolOptions", response.data.school_options);
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * デジタルペーパーの公開状態切り替え
     ******************************/

    const changeDigitalPublished = async (sheet: any, flg: boolean) => {
      
      if(!window.confirm("公開状態を切り替えます。よろしいですか？")){
        return;
      }
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_digital_sheet_published/${sheet.id}`, {flg: flg}).then(response => {
        alert("処理が完了しました。");
        //modalDigitalPaperPublishSetting.value.hide();
        state.sheets.filter(x => x.id == sheet.id).forEach(x => {
          x.digital_sheet_published = flg;
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * デジタルペーパーの公開予約
     ******************************/

    const updateDigitalPaperPublishSchedule = async (sheet: any) => {
      
      state.errors = [];

      if(!sheet.test_start_datetime_at && sheet.test_end_datetime_at){
        alert("開始日時が設定されていません。");
        return;
      }

      if(sheet.test_start_datetime_at && !sheet.test_end_datetime_at){
        alert("終了日時が設定されていません。");
        return;
      }

      if(!window.confirm("公開予約を登録します。よろしいですか？")){
        return;
      }

      const param = {
        test_start_datetime_at: sheet.test_start_datetime_at,
        test_end_datetime_at: sheet.test_end_datetime_at,
      };

      await http.post(`/api/teacher/sheet_list/update_digital_paper_publish_schedule/${sheet.id}`, param).then(response => {
        alert("処理が完了しました。");
        //modalDigitalPaperPublishSetting.value.hide();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Homework);
      state.condition = context.root.$store.state.homeworkSheetListCondition;
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      modalDigitalPaperPublishSetting,
      search,
      searchClick,
      convertToHms,
      rowSpan,
      tdStyle,
      trStyle,
      convertEndDate,
      isSettingCompleted,
      clearCondition,
      changePage,
      addSheetClick,
      saitenSettingClick,
      reload,
      schoolChanged,
      changeDigitalPublished,
      openDigitalPaperPublishSettingModal,
      updateDigitalPaperPublishSchedule,
    }
  }
});
